// Actions to do something with the decoded emailaddresses
function mailToEmailAddress () {
  const emailaddresses = document.getElementsByClassName('--email');

  if (emailaddresses) {
    for (let index = 0; index < emailaddresses.length; index++) {
      const item = emailaddresses[index];
      const emailValue = emailaddresses[index].getAttribute('data-email');
      let emailAddress = '';

      if (emailValue !== null) {
        emailAddress = decodeURIComponent(atob(emailValue));

        item.addEventListener("click", function () {
          document.location = 'mailto:' + emailAddress;
        });
      }
    }
  }
}

mailToEmailAddress();
